<template>
  <div>
    <div>
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Live</v-card-title>
          <v-btn class="ml-auto" icon @click="close()">
            <v-icon small class="white--text">mdi-window-close</v-icon>
          </v-btn>
        </div>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="lives"
            :search="search"
            class="border"
            show-select
            :hide-default-footer="false"
            :single-select="singleSelect"
            v-model="selectedLive"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { listLives } from "../graphql/Query";

export default {
  name: "LiveEvents",
  props: ["selected_lives"],
  data: () => ({
    singleSelect: false,
    deleteConfirmDialog: false,
    search: "",
    title: "",
    lives: [],
    selectedLive: [],
    errors: [],
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
        sortable: false
      },
      { text: "Title", value: "title", sortable: false },
      { text: "Live Manager", value: "managers[0].email", sortable: false }
    ],
    liveTitle: "",
    options: {}
  }),
  created() {
    this.initialize();
  },
  computed: {},
  methods: {
    async initialize() {
      await this.getListLives();
      // 이미 선택된 라이브 목록 체크
      this.lives.forEach(item => {
        if (
          Array.isArray(this.selected_lives) &&
          this.selected_lives.find(liveId => liveId == item.id)
        ) {
          this.selectedLive.push(item);
        }
      });
    },
    close() {
      const selected = this.selectedLive.map(item => item.id);
      this.$emit("onCloseCollectionLiveDialog", selected);
    },
    async getListLives() {
      /**
       * 채널에 해당하는 그룹목록 가져오기
       */
      const channel_id = this.$store.state.channelId;
      const limit = undefined;
      const nextToken = undefined;

      try {
        const { data } = await this.$apollo.query({
          query: listLives,
          variables: {
            channel_id,
            limit,
            nextToken
          },
          fetchPolicy: "no-cache"
        });
        console.log("[LiveList]", data);
        if (data.listLives.items) {
          this.lives = data.listLives.items;
          console.log(this.lives);
          // 라이브 아이템에 링크 추가
          this.lives.forEach(item => {
            // item.link = process.env.VUE_APP_BASE_URL + "/live/" + item.id;
            item.link = item.id;
          });
          // 정렬
          this.lives.sort((a, b) => (a.title > b.title ? 1 : -1));
        }
      } catch (e) {
        console.log("[LiveList] listLives failed", e);
      }
    }
  }
};
</script>
<style></style>
